import React from "react";
import { useNavigate } from "react-router-dom";
import profile_pic from "../../Assets/profile_pic.png";

function Home() {
  const TextLink = ({ link, text }) => {
    const navigate = useNavigate();
    const isExternal = link.startsWith("http");

    const handleClick = () => {
      if (isExternal) {
        window.open(link, "_blank");
      } else {
        navigate(link);
      }
    };

    return (
      <span>
        &nbsp;
        <span className="link-text" onClick={handleClick}>
          {text}
        </span>
      </span>
    );
  };

  return (
    <section className="home-header">
      <h1 className="heading-name">
        Hi. I'm
        <strong className="main-name"> Te-Yen Chou (Andy)</strong>
      </h1>
      <h3>
        <strong> CMU SCS </strong>
      </h3>
      <div className="home-intro">
        <div className="home-ctn1">
          <div className="home-about-body">
            <p className="home-about-paragraph">
              I'm a Software Engineer II at{" "}
              <TextLink
                text={"YugabyteDB"}
                link={"https://www.yugabyte.com/"}
              />{" "}
              and I graduated from
              <TextLink text={"CMU"} link={"https://www.cmu.edu/"} />, where I learn databases, distributed system, and formal methods
              <br />
              <br />
              Previously I interned at
              <TextLink text={"Amazon"} link={"https://www.amazon.com/"} />{" "}
              (worked on payment infra) and
              <TextLink
                text={"TSMC"}
                link={"https://www.tsmc.com/english"}
              />{" "}
              (built a system that optimize SQL queries)
              <br />
              <br />
              I'm interested in building database management system, query
              optimization, distributed system and large scale systems.
              <br />
              <br />
              I am also a very good
              <TextLink text={"magician"} link={"/magic"} /> 🕊️.
            </p>
          </div>
          <img src={profile_pic} alt="home pic" className="img-fluid" />
        </div>
      </div>
    </section>
  );
}

export default Home;
